import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const SURVEY_BANNER_DISMISSED_KEY = 'ccomx-survey-banner-dismissed';

@Injectable({
  providedIn: 'root',
})
export class SurveyBannerService {
  isDismissed(): boolean {
    const storedSignature = localStorage.getItem(SURVEY_BANNER_DISMISSED_KEY);
    const currentSignature = this.getBannerSignature();

    if (!storedSignature) {
      return this.migrateLegacySessionDismissal();
    }

    if (storedSignature === 'true') {
      localStorage.setItem(SURVEY_BANNER_DISMISSED_KEY, currentSignature);
      return true;
    }

    return storedSignature === currentSignature;
  }

  dismiss(): void {
    localStorage.setItem(SURVEY_BANNER_DISMISSED_KEY, this.getBannerSignature());
    sessionStorage.removeItem(SURVEY_BANNER_DISMISSED_KEY);
  }

  private getBannerSignature(): string {
    const { customMessage, customUrl } = environment.banner;
    return JSON.stringify({ customMessage, customUrl });
  }

  private migrateLegacySessionDismissal(): boolean {
    if (sessionStorage.getItem(SURVEY_BANNER_DISMISSED_KEY) !== 'true') {
      return false;
    }

    this.dismiss();
    return true;
  }
}
